import { IClassEnvironmentScore } from "./interfaces/class-environment-score.interface";

export class ClassEnvironmentScore implements IClassEnvironmentScore {
  vaUserId: string;
  observed: Date; // Localized
  classroomId: number;
  preOrPost: boolean; // Pre = 0, Post = 1
  score: number;
  IsCurriculum: boolean;
  ProvideCurriculm: string;
}